import { ArticleSection } from "./articleSection.descriptor";
import { BlockWithTitle } from "./blocWithTitle.descriptor";
import { ContactForm } from "./contactForm.descriptor";
import { Iframe } from "./iframe.descriptor";
import { Mailto } from "./mailto.descriptor";
import { PresentationBox } from "./presentationBox.descriptor";
import { Subpage } from "./subpage.descriptor";
import { SubpageSearch } from "./subpageSearch.descriptor";
import { TextBlockWithTitle } from "./textBlockWithTitle.descriptor";
import { DescriptionCardWithLogo } from "./descriptionCardWithLogo.descriptor";
import { ProductBlock } from "./productBlock.descriptor";
import { ContactBlock } from "./contactBlock.descriptor";
import { DescriptionSection, DescriptionSectionItem, } from "./descriptionSection.descriptor";
import { SolutionCard } from "./solutionCard.descriptor";
import { OfferingCard } from "./offeringCard.descriptor";
import { ColumnWithIconItem, ColumnsWithIcon, } from "./columnsWithIcon.descriptor";
import { StatCard } from "./statCard.descriptor";
import { DescriptionTabs, DescriptionTabsItem, } from "./descriptionTabsComponent.descriptor";
import { IllustrationTabs, IllustrationTabItem, } from "./illustrationTabPanel.descriptor";
import { DescriptionServices, DescriptionServicesItem, } from "./descriptionService.descriptor";
import { WitnessCard } from "./witnessCard.descriptor";
import { Steps, Step } from "./steps.descriptor";
import { ColorImageBlock } from "./colorImageBlock.descriptor";
import { GradientButton } from "./gradientButton.descriptor";
import { OfferPresentationCard } from "./offerPresentationCard.descriptor";
import { InfosBlock } from "./infosBlock.descriptor";
import { ListWrap, ListWrapItem } from "./listWrap.descriptor";
import { ListInfos, ListInfosItem } from "./listInfos.descriptor";
import { CardPrice, CardPriceRowItem } from "./cardPrice.descriptor";
import { CardLabel } from "./cardLabel.descriptor";
export default [
    ArticleSection,
    PresentationBox,
    BlockWithTitle,
    ColorImageBlock,
    TextBlockWithTitle,
    DescriptionServices,
    DescriptionServicesItem,
    DescriptionCardWithLogo,
    CardLabel,
    WitnessCard,
    OfferPresentationCard,
    CardPrice,
    CardPriceRowItem,
    InfosBlock,
    ListWrap,
    ListWrapItem,
    ListInfos,
    ListInfosItem,
    DescriptionTabs,
    DescriptionTabsItem,
    IllustrationTabs,
    IllustrationTabItem,
    GradientButton,
    Subpage,
    SubpageSearch,
    ContactForm,
    Mailto,
    Iframe,
    ProductBlock,
    ContactBlock,
    Steps,
    Step,
    DescriptionSection,
    DescriptionSectionItem,
    SolutionCard,
    OfferingCard,
    ColumnsWithIcon,
    ColumnWithIconItem,
    StatCard,
];
